import { useState } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import Stack from "@mui/material/Stack";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import Alert from "@mui/material/Alert";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";
import { ApiUrl } from "../config/api_url";
import Logo from "../assets/liyulogo.png";

export default function LoginForm() {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [isError, setIsError] = useState({ value: false, message: "" });

  const onSubmit = (e) => {
    e.preventDefault();

    if (!phone || !password) {
      setIsError({ value: true, message: "All fields are required!" });
      return;
    }

    setIsLoading(true);

    const loginUrl = `${ApiUrl}/customers/auth/login`;

    axios
      .post(
        loginUrl,
        {
          phone: phone,
          password: password,
        },
        {
          headers: {
            "x-api-key": "zR0ClHzLGi",
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        if (res.data.success) {
          localStorage.setItem("liyu_phone", phone);
          localStorage.setItem("liyu_login_token", res.data.data.access_token);
          history.push("/");
        } else {
          setIsError({
            value: true,
            message: res.data.message || "Invalid login credentials",
          });
        }
      })
      .catch((err) =>
        setIsError({
          value: true,
          message: err.response?.data?.message || err.message,
        })
      )
      .finally(() => setIsLoading(false));
  };

  return (
    <Container maxWidth="sm">
      <Paper elevation={3} sx={{ padding: { xs: 2, sm: 4 }, mt: 15 }}>
        <Avatar
          alt="Liyu bus"
          src={Logo}
          sx={{ width: 100, height: 100, mx: "auto" }}
        />

        <Typography
          variant="h5"
          component="h4"
          gutterBottom
          align="center"
          mt={3}
        >
          Liyu Bus Portal
        </Typography>

        <form onSubmit={onSubmit}>
          <Stack alignItems="center" spacing={4}>
            {isError.value && <Alert severity="error">{isError.message}</Alert>}

            <TextField
              fullWidth
              type="text"
              label="Phone"
              variant="standard"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />

            <TextField
              fullWidth
              type="password"
              label="Password"
              variant="standard"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />

            <Button
              fullWidth
              type="submit"
              variant="contained"
              disabled={isLoading}
            >
              {isLoading ? "Logging in..." : "Login"}
            </Button>
            <Typography variant="body2" align="center">
              Don’t have an account? <Link to="/signup">Sign Up</Link>
            </Typography>
          </Stack>
        </form>
      </Paper>
    </Container>
  );
}
